import type { OnBoardingStore } from "@/Modules/OnBoarding/Store";
import type { AnswersIds } from "@/Modules/Models/Domain/OnBoarding";
import type { UpdateRegistrationApiQuery } from "@/Modules/Models/Api/OnBoarding";
import { TherapyType } from "@/Modules/Models/Domain/OnBoarding";

import OnBoardingAPIConnector from "@/Services/TherapyApi/OnBoarding";

import useUserStore from "@/Modules/User/Store";

import { hasValue } from "@/Utils/Objects";
import { danger } from "@/Utils/Debug";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

class UpdateUserRegistrationActionHandler {
  constructor(
    private readonly onBoardingStore: OnBoardingStore,
    private readonly userStore = useUserStore(),
    private readonly onBoardingApiConnector: OnBoardingAPIConnector = new OnBoardingAPIConnector()
  ) {}

  public async handle() {
    const onBoardingData = this.onBoardingStore.answers;
    const apiQuery = this.transformDataToApiQuery(onBoardingData);

    this.onBoardingStore.hasErrorInProcess = false;
    this.onBoardingStore.errorCode = null;
    this.onBoardingStore.isLoading = true;

    try {
      if (hasValue(this.userStore.user)) {
        const uuid = this.userStore.user.id;

        await this.onBoardingApiConnector.updateRegistrationUser(apiQuery, uuid);
        this.onBoardingStore.isUpdateRegister = true;
      }

      this.onBoardingStore.setNextStep(null);

      await this.userStore.setUser();
    } catch (err: unknown) {
      const code = isApiError(err) ? err["error_code"] : null;

      danger(code);

      this.onBoardingStore.hasErrorInProcess = true;
    } finally {
      this.onBoardingStore.isLoading = false;
    }
  }

  private transformDataToApiQuery(
    onBoardingData: Partial<Record<AnswersIds, string>>
  ): UpdateRegistrationApiQuery {
    return {
      is_couple: onBoardingData.therapy_type === TherapyType.COUPLE,
      couple_age_detailed: onBoardingData.couple_age,
      couple_gender: onBoardingData.couple_gender,
      patient_subarea: onBoardingData.sub_area ? onBoardingData.sub_area : "",
      tell_me_more: onBoardingData.tell_me_more,
      gender_preference: onBoardingData.therapist_gender_preferences
        ? onBoardingData.therapist_gender_preferences
        : "",
      availability: onBoardingData.therapist_availability ? onBoardingData.therapist_availability : "",
      privacy_policy_at: parseInt(onBoardingData.privacy_policy_at!),
    };
  }
}

export default UpdateUserRegistrationActionHandler;
